import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useSnackBar from '../../../../../hooks/useSnackBar/useSnackBar';
import useHttpError from '../../../../../hooks/useHttpError/useHttpError';

import UsersService from '../../../../../services/Users/UsersService';

import { Device, SimCreateRequest } from '../../../../../models/UserDevicesModels';

function useAssignSim(onClose: () => void, onAssignSimSuccess: () => void, userId?: string, deviceFromProps?: Device) {
  const snackBar = useSnackBar();
  const [t] = useTranslation();
  const { getHttpReason } = useHttpError();
  const [isLoading, setIsLoading] = useState(false);
  const [availableDevices, setAvailableDevices] = useState<Device[]>([]);

  /**
   * Requests the available devices
   * @param
   */
  const getAvailableDevices = (id: string) => {
    setIsLoading(true);
    UsersService.api
      .fetchUserDevices(id, { status: 'ALL', deviceOnly: false })
      .then(
        (res) => {
          setAvailableDevices(res.data.devices);
        },
        () => {
          snackBar.showSnackBar(t('pages.userDetails.upgradeDeviceDrawer.devicesAvailableError'), 'error');
        },
      )
      .finally(() => setIsLoading(false));
  };

  /**
   * Adds a new device
   * @param req
   * @param errorCallback
   */
  const assignSim = async (req: SimCreateRequest) => {
    UsersService.api.createSim(req).then(
      () => {
        snackBar.showSnackBar(t('pages.assignSim.assignSimSuccess'), 'success');
        onClose();
        onAssignSimSuccess();
        setIsLoading(false);
      },
      (res) => {
        setIsLoading(false);
        const error = getHttpReason(res.response.data, t('pages.assignSim.assignSimError'));
        snackBar.showSnackBar(error, 'error');
      },
    );
  };

  useEffect(() => {
    if (userId && !deviceFromProps) {
      getAvailableDevices(userId);
    }
  }, [userId]);

  return { isLoading, assignSim, availableDevices };
}

export default useAssignSim;
